export function money(n: number): string {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  });
}

export function money2(n: number): string {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
